export default __webpack_public_path__ + "static/media/11.d38c75b2.jpg";